import {
  styled,
  Tooltip,
  tooltipClasses,
  Typography
} from '@mui/material';
import { Link } from 'react-router-dom';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: transparent;
        display: flex;
        text-decoration: none;
        margin: 0 10px;
        margin-left: 10px;
        font-weight: ${theme.typography.fontWeightBold};
        justify-content: center;
        align-items: center;
        height: 55px;
        overflow: hidden;
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

function Logo() {

  // const setLogoAndName = async () => {
  //   try {
  //     const { data: orgData } = await OrganisationService.getById(
  //       user?.organisation
  //     );

  //     if (orgData?.type === 'MANUFACTURER') {
  //       setLogo(orgData?.logo || `/static/images/logos/TraxsmartVLTD.png`);
  //       setName(orgData?.brandName || 'Traxsmart');
  //     } else {
  //       // find parent manufacturer and set logo
  //       const { data: association } = await OrganisationAssociationService.get({
  //         childOrganisationId: orgData?.id,
  //         parentOrgType: 'MANUFACTURER'
  //       });
  //       const parentManufacturer =
  //         association.length > 0 ? association[0]?.parentOrganisationId : null;
  //       if (parentManufacturer) {
  //         const { data } = await OrganisationService.getById(
  //           parentManufacturer
  //         );
  //         setLogo(data?.logo || `/static/images/logos/TraxsmartVLTD.png`);
  //         setName(data?.brandName || 'Traxsmart');
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // useEffect(() => {
  //   // if no org , set from flavour logo
  //   if (!user?.organisation) {
  //     setLogo(`/static/images/logos/TraxsmartVLTD.png`);
  //     setName("Traxsmart");
  //     return;
  //   }
  //   setLogoAndName();
  // }, [user]);

  return (
    <TooltipWrapper
      title={
        // name
        'Traxsmart'
      }
      arrow
    >
      <LogoWrapper to="/">
        <img
          style={{
            objectFit: 'contain',
            maxWidth: '80%',
            maxHeight: '80%',
            height: 'auto',
            width: 'auto'
          }}
          src={
            // organisation?.attributes?.logo ||
            // logo
            `/static/images/logos/kingkong-logo.png`
          }
          alt={`${'Traxsmart'} logo`}
        />

        <Typography
          sx={{
            ml: 1,
            fontSize: '1.5em',
            fontWeight: 'bold',
            color: 'text.secondary'
          }}
        >
          {
            // name
            'Trax IOT Core'
          }
        </Typography>
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
